export default __webpack_public_path__ + "static/media/18.d18961a8.webp";